import React from 'react';
import { useFormikContext } from 'formik';
import CostumDatePicker from '../../Form/DatePicker';

const DatePickerWrapper = (props) => {
  const formik = useFormikContext();
  return <CostumDatePicker {...props} formik={formik} className="employee-balance-date-picker" />;
};

export default DatePickerWrapper; 